import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(3.5 2)",
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "M12.94,7.47h-.94c-.92.85-2.15,1.37-3.51,1.37s-2.58-.52-3.51-1.37h-.94c-2.05,0-3.7,1.65-3.7,3.68v8.84h16.3v-8.84c0-2.04-1.66-3.68-3.7-3.68" }), /* @__PURE__ */ _jsx("path", { d: "M8.5,7.37c2.05,0,3.7-1.65,3.7-3.69s-1.66-3.68-3.7-3.68-3.7,1.65-3.7,3.68,1.66,3.69,3.7,3.69" })]
	})
});
export default SvgUsers;
